import { union } from '@wix/wix-data-client-common/dist/esm/infra/unionType'
import { union as wixUnion } from '@wix/wix-data-client-wix-code-adt'
import FilterExpression from '../../business-logic/filter/FilterExpression'
import { getFieldByFieldName } from '@wix/wix-data-client-common/dist/esm/business-logic/fields/fieldSelectors'
import {
  isReferencingField,
  isMultiReferenceField,
} from '@wix/wix-data-client-common/dist/esm/business-logic/fields/fieldQueries'
import { FilterCondition } from '@wix/wix-data-client-common/dist/esm/filterCondition'

const PanelValue = union('PanelValue', {
  Owner: () => {},
  Static: ({ value }) => ({
    value,
  }),
  Referencing: ({ dataset, filterId }) => ({ dataset, filterId }),
  StaticMultiRef: ({ referencedCollectionItems, id }) => ({
    referencedCollectionItems,
    id,
  }),
  Dataset: ({ dataset, datasetField, filterId }) => ({
    dataset,
    datasetField,
    filterId,
  }),
  Slug: ({ slug }) => ({ slug }),
  Empty: () => {},
})

PanelValue.of = ({ fields, filterExpression }) => {
  return FilterExpression.of(filterExpression).matchWith({
    ByCurrentUser: PanelValue.Owner,
    ByValue: ({ field: fieldName, condition, value }) => {
      const field = getFieldByFieldName(fields, fieldName)
      return isMultiReferenceField(field)
        ? PanelValue.StaticMultiRef({ id: value[0] })
        : [FilterCondition.IS_EMPTY, FilterCondition.IS_NOT_EMPTY].includes(
              condition,
            )
          ? PanelValue.Empty()
          : PanelValue.Static({ value })
    },
    ByDataset: ({ dataset, datasetField, filterId, field: fieldName }) => {
      const field = getFieldByFieldName(fields, fieldName)
      return isReferencingField(field)
        ? PanelValue.Referencing({ dataset, filterId })
        : PanelValue.Dataset({ dataset, datasetField, filterId })
    },
    BySlug: PanelValue.Slug,
  })
}

const PanelState = wixUnion('FilterPanelState', {
  Loading: () => {},
  Ready: ({
    panelMode,
    isModified,
    fields,
    controllerType,
    controllers,
    collections,
    components,
    selectedField,
    selectedCondition,
    selectedValue,
    selectedCollection,
    isTPACollection,
    isSlugFilterAllowedInPage,
    origin,
    allowValueSourceSelection,
  }) => ({
    panelMode,
    isModified,
    fields,
    controllerType,
    controllers,
    collections,
    components,
    selectedField,
    selectedCondition,
    selectedValue,
    selectedCollection,
    isTPACollection,
    isSlugFilterAllowedInPage,
    origin,
    allowValueSourceSelection,
  }),
  Closing: ({
    panelMode,
    isModified,
    fields,
    controllerType,
    controllers,
    collections,
    components,
    selectedField,
    selectedCondition,
    selectedValue,
    selectedCollection,
    isTPACollection,
    isSlugFilterAllowedInPage,
    origin,
    allowValueSourceSelection,
  }) => ({
    panelMode,
    isModified,
    fields,
    controllerType,
    controllers,
    collections,
    components,
    selectedField,
    selectedCondition,
    selectedValue,
    selectedCollection,
    isTPACollection,
    isSlugFilterAllowedInPage,
    origin,
    allowValueSourceSelection,
  }),
})

export { PanelValue, PanelState }
